export default __webpack_public_path__ + "static/media/logout-icon.9174dab8.svg";